/**
 * Utility function to check if an item is not an instance of Error.
 * If an ErrorType is provided, it checks if the item is not an instance of that specific Error type.
 * Otherwise, it checks against the base Error class.
 */
export function isNotError<T>(
  item: T | Error,
  ErrorType?: new () => Error,
): item is T {
  if (ErrorType === undefined) {
    return !(item instanceof Error);
  }

  return item instanceof Error && !(item instanceof ErrorType);
}
